<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" md="12" class="text-left my-3">
                <inter-card>
                    <h4 class="text-primary">Inserisci i nominativi</h4>
                    <p>Selezionare dalla rubrica i nominativi delle persone che parteciperanno all'iniziativa e per cui si richiede un biglietto.<br />In questa fase &egrave; importante che <strong>il numero di adulti partecipanti sia minore o uguale al numero di minori</strong>; in caso contrario, infatti, la procedura non accetter&agrave; l'inserimento e non sar&agrave; possibile portare a termine la richiesta.<br />Sar&agrave; possibile modificare i nominativi inseriti fino al termine massimo indicato o fintanto che il pagamento non sar&agrave; stato effettuato.</p>
                </inter-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="mx-1 flex-grow-1"
                     v-for="(sector, index) in match.sectors" v-bind:key="index">
                    <b-card no-body v-if="sectorsStatus[sector.id]">
                        <b-card-header class="p-1 text-center">
                            {{sector.code}}
                        </b-card-header>
                        <div class="p-1 text-center">
                            {{sectorsStatus[sector.id].busy}} / {{sectorsStatus[sector.id].total}}
                        </div>
                    </b-card>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="3">
                <inter-card class="mb-3"
                            titleIcon="flaticon-baby"
                            title="Minori">
                    <h2 class="my-0 text-center">{{totalJunior}}</h2>
                </inter-card>
            </b-col>
            <b-col cols="12" md="3">
                <inter-card
                        class="mb-3"
                        titleIcon="flaticon-employee"
                        :title="`Adulti`">
                    <h2 class="my-0 text-center">{{totalSenior}}</h2>
                </inter-card>
            </b-col>
            <b-col cols="12" md="3">
                <inter-card
                        class="mb-3"
                        titleIcon="flaticon-group"
                        :title="`Totale (min. ${this.match.tickets_threshold} )`">
                    <h2 class="my-0 text-center">{{totalSenior + totalJunior}}</h2>
                </inter-card>
            </b-col>
            <b-col cols="12" md="3">
                <inter-card
                        class="mb-3"
                        titleIcon="flaticon-euro"
                        title="Importo">
                    <h2 class="my-0 text-center">{{totalAmount | currency}}</h2>
                </inter-card>
            </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-center">
            <b-col cols="12" md="5" class="mb-3">
                <inter-card
                        :noBody="true"
                        titleIcon="flaticon-employee"
                        title="Adulti">
                    <div v-if="seniorContacts.length">
                        <b-list-group class="list-contacts">
                            <b-list-group-item v-for="(contact, index) in seniorContacts" v-bind:key="index">
                                <div class="d-flex">
                                    <div>{{contact.surname}} {{contact.name}}</div>
                                    <div class="ml-auto">
                                        <b-form-checkbox v-model="contact.selected" switch>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                    <div v-else>
                        <b-alert variant="warning" show>
                            Non ci sono contatti maggiorenni
                        </b-alert>
                    </div>
                </inter-card>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <inter-card
                        :noBody="true"
                        titleIcon="flaticon-baby"
                        title="Minori">
                    <div v-if="juniorContacts.length">
                        <b-list-group class="list-contacts">
                            <b-list-group-item v-for="(contact, index) in juniorContacts" v-bind:key="index">
                                <div class="d-flex">
                                    <div>{{contact.surname}} {{contact.name}}</div>
                                    <div class="ml-auto">
                                        <b-form-checkbox v-model="contact.selected" switch>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                    <div v-else>
                        <b-alert variant="warning" show>
                            Non ci sono contatti minorenni
                        </b-alert>
                    </div>
                </inter-card>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>

    import InterCard from "../../../../components/card/InterCard";
    import _ from 'lodash';
    import Moment from 'moment';
    import Match from '@/models/Match';

    export default {
        name: "SocietyMatchWizardsStepFour",
        components: {InterCard},
        props: {
            contacts: {
                type: Array,
                default: () => []
            },
            sectorsStatus: {
                type: Array,
                default: () => []
            },
            match: {
                type: Object,
                default: () => Object.assign({}, Match)
            }
        },

        computed: {
            juniorContacts: function () {
                const list = _.filter(this.contacts, (item) => {
                    const age = Moment().diff(item.birth_date, 'years', false);
                    return age < 18;
                });
                return _.sortBy(list, ['surname'])
            },
            seniorContacts: function () {
                const list = _.filter(this.contacts, (item) => {
                    const age = Moment().diff(item.birth_date, 'years', false);
                    return age >= 18;
                });
                return _.sortBy(list, ['surname'])
            },
            totalSenior: function () {
                return _.filter(this.seniorContacts, (item) => {
                    return item.selected;
                }).length;
            },
            totalJunior: function () {
                return _.filter(this.juniorContacts, (item) => {
                    return item.selected;
                }).length;
            },
            totalAmount: function () {
                return (this.totalSenior+this.totalJunior) * this.match.price;
            }
        },
        methods: {
            getSelectedContacts: function () {

                return _.filter(this.contacts, (item) => {
                    return item.selected;
                })
            },
            validate: function () {

                if ((this.totalJunior + this.totalSenior) < this.match.tickets_threshold) {
                    this.$bvToast.toast('Devi inserire almento ' + this.match.tickets_threshold + ' nominativi', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }

                if (this.totalSenior > this.totalJunior ) {
                    this.$bvToast.toast('Gli adulti devono essere numericamente minori o uguali ai minori', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }

                return true;


            },
        }
    }
</script>

<style scoped lang="scss">

    .list-contacts {
        min-height: 150px;
        max-height: 266px;
        overflow: auto;
    }

</style>
